export const configurationValidator = (quoteOperationExpenses: any) => {
  if (!quoteOperationExpenses) return false;

  const { workforce, quoteExpenses, mileage, grossProfit } = quoteOperationExpenses;

  const validWorkforce =
    Array.isArray(workforce) &&
    workforce.length > 0 &&
    workforce.every(
      (w) =>
        !!w.type &&
        Number(w.quantity) > 0 &&
        Number(w.hoursPerStaff) > 0 &&
        Number(w.ratePerHour) > 0
    );

  const validExpenses =
    !!quoteExpenses &&
    Number(quoteExpenses.benefits) >= 0 &&
    Number(quoteExpenses.workCompensation) >= 0 &&
    Number(quoteExpenses.tax) >= 0;

  const validMileage =
    !!mileage &&
    (mileage.hasMileage === false ||
      (mileage.hasMileage === true && Number(mileage.mileageRate) > 0));

  const validGrossProfit =
    !!grossProfit && Number(grossProfit.grossProfit) > 0;

  return validWorkforce && validExpenses && validMileage && validGrossProfit;
};
